<template lang="pug">
  div(class="content")
    .md-layout.md-alignment-center-center
        .md-layout-item.md-size-100.centered
            h1 USIT Trading
        .md-layout-item.md-size-35.centered
          .logo-img
            img(:src='imgLogo', alt='')
          p(style="margin-top: 50px; font-size: 250%;") Coming soon
</template>

<script>
export default {
  props: {
    imgLogo: {
      type: String,
      default: require("@/assets/img/usit-logo-black.png")
    },
  }
}
</script>

<style scoped>
  .centered {
    text-align: center;
  }
  .logo-img {
    width: 100%;
    margin-left: 3px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Trading/TradingSplash.vue